// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F9JTT","option":"styles_option__1kl-F","active":"styles_active__36VK6"};